import React from 'react';

import styles from './Homepage.module.css';
import logo from '../../images/logo.svg';
import firstimg from '../../images/img1st.svg';
import orgtri from '../../images/orgtri.svg';
import blueu from '../../images/blueu.svg';
import view2 from '../../images/view2.png';
import container3 from '../../images/container3.png';
import img2 from '../../images/img2.svg';
import img3 from '../../images/img3.svg';
import img4 from '../../images/img4.svg';
import img5 from '../../images/img5.svg';
import img6 from '../../images/img6.svg';
import orgtri2 from '../../images/orgtri2.svg';
import blueu2 from '../../images/blueu2.svg';
import editicon from '../../images/editicon.svg';


import { useNavigate } from "react-router-dom";

function Homepage() {
  const navigate = useNavigate();
  const gotoRegister = () => {
    navigate("/register");
  }
  const gotoLogin = () => {
    navigate("/login");
  }
  return(
    <div className={styles.homepage}>
      <div className={styles.navbar}>
        <div className={styles.navbar1}>
          <textview>FormBot
          <img src={logo} alt="logo"/>
          </textview>
          <div className={styles.navbar2}>
            <button className={styles.signin} onClick={gotoLogin}>Sign in</button>
            <button className={styles.register1} onClick={gotoRegister}>Create a FormBot</button>
          </div>
        </div>
      </div>
      <div className={styles.container1}>
          <div className={styles.view1}>
           
          <img className={styles.orgtri} src={orgtri} alt="orgtri"/>
          <h1>Build advanced chatbots
          visually</h1>
          <p>Typebot gives you powerful blocks to create unique chat experiences. Embed them
          anywhere on your web/mobile apps and start collecting results like magic.</p>
          <button onClick={gotoRegister}>Create a FormBot  for free</button>
          <img className={styles.blueu} src={blueu} alt="blueu"/>
         
         
          </div>
          
         <img className={styles.firstimg} src={firstimg} alt="firstimg"/>
         
      </div>
      
      <div className={styles.container2}>
          
           
          <h1>Replace your old school forms with <br/>chatbots</h1>
          <p>Typebot is a better way to ask for information. It leads to an increase in customer satisfaction and retention and multiply by <br/>3
          <br/>your conversion rate compared to classical forms.</p>
          
         <img className={styles.view2} src={view2} alt="firstimg"/>
         
      </div>
      <div className={styles.container31}>
      <img className={styles.container3} src={container3} alt="container3"/>
         
      </div>
      <div className={styles.container4}>
        <h1>Embed it in a click</h1>
        <p>Embedding your typebot in your applications is a walk in the park. Typebot gives you several step-by-step platform- specific instructions. Your typebot will always feel "native".</p>
        <img className={styles.img2} src={img2} alt="img2"/>
          
      </div>
      <div className={styles.container5}>
      <img className={styles.img3} src={img3} alt="img3"/>
        
        <h1>Integrate with any platform</h1>
        <p>Typebot offers several native integrations blocks as well as instructions on
        how to embed typebot on particular platforms</p>  
      </div>
      <div className={styles.container6}>
      
        <h1>Collect results in real-time</h1>
        <p>One of the main advantage of a chat application is that you collect the user's responses on each question.
        <br/><span>You won't lose any valuable data.</span> </p>
        <img className={styles.img4} src={img4} alt="img4"/>
         
      </div>
      <div className={styles.container7}>
      
        <h1>And many more features</h1>
        <p className={styles.Typebot}>Typebot makes form building easy and comes with powerful features</p>
        <img className={styles.img5} src={img5} alt="img5"/>
      </div>
      <div className={styles.container77}>
        <p className={styles.loved}>Loved by teams and creators from all around the world</p>
        <img className={styles.img6} src={img6} alt="img6"/>
         
      </div>
      <div className={styles.container8}>
        <img className={styles.orgtri2} src={orgtri2} alt="org2"/>
        <img className={styles.blueu2} src={blueu2} alt="blueu2"/>
            <div className={styles.contview8}>
           
               <h1>Improve conversion and user engagement
               with FormBots </h1>
               <button onClick={gotoRegister}>Create a FormBot</button>
               <p>No trial. Generous <span>free</span> plan.</p>
              
          
           </div>
      </div>
      <div className={styles.container9}>
        <p className={styles.p1}>Made with ❤️ by
        <br/>@cuvette</p>
        <p className={styles.p2}>Status<img src={editicon} alt='editicon'/></p>
        <p className={styles.p3}>Documentation<img src={editicon} alt='editicon'/></p>
        <p className={styles.p4}>Roadmap<img src={editicon} alt='editicon'/></p>
        <p className={styles.p5}>Pricing</p>
        <p className={styles.p6}>Discord<img src={editicon} alt='editicon'/></p>
        <p className={styles.p7}>GitHub repository<img src={editicon} alt='editicon'/></p>
        <p className={styles.p8}>Twitter<img src={editicon} alt='editicon'/></p>
        <p className={styles.p9}>LinkedIn<img src={editicon} alt='editicon'/></p>
        <p className={styles.p10}>OSS Friends</p>
        <p className={styles.p11}>About</p>
        <p className={styles.p12}>Contact</p>
        <p className={styles.p13}>Terms of Service</p>
        <p className={styles.p14}>Privacy Policy</p>
        
      </div>
    </div>
  )
}

export default Homepage;
